import React from 'react';
import classNames from 'classnames';
import { CartItem } from './cart-items/cart-item.jsx';

export const UpsellItems = ({ items, onAddItem, isPending }) => {
  const isHidden = !items || items.length === 0;

  return (
    <div
      aria-hidden={isHidden}
      className={classNames('cart-popup__upsell-collapser', {
        'cart-popup__upsell-collapser--collapsed': isHidden
      })}
    >
      <div className="cart-popup__upsell-items">
        <p className="cart-popup__upsell-items-title">Customers often add</p>
        {items?.map((item) => (
          <CartItem
            key={item.variantId}
            discountPrice={item.finalPrice}
            flavor={item.flavor}
            image={item.image}
            isAddPending={isPending ? isPending(`add:${item.variantId}`) : false}
            productTitle={item.productTitle}
            variantTitle={item.variantTitle}
            onAddItem={() => onAddItem(item.variantId)}
          />
        ))}
      </div>
    </div>
  );
};
